import { Navbar } from '../bordeaux/components/Navbar';
import { Hero } from '../bordeaux/components/Hero';
import { Services } from '../bordeaux/components/Services';
import { BayWindows } from '../bordeaux/components/BayWindows';
import { WhatsAppDiagnostic } from '../bordeaux/components/WhatsAppDiagnostic';
import { Contact } from '../bordeaux/components/Contact';
import { Footer } from '../bordeaux/components/Footer';
import { useEffect } from 'react';

export default function Lormont() {
  useEffect(() => {
    document.title = "Réparation Fenêtres Lormont | PVC Alu Bois | Baies Vitrées | FenetrePro";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Expert en réparation de fenêtres à Lormont ✓ PVC, Aluminium, Bois ✓ Baies vitrées toutes marques ✓ Intervention rapide ✓ Devis gratuit ✓ Artisan local Lormont');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'réparation fenêtres Lormont, fenêtres PVC Lormont, fenêtres aluminium Lormont, baies vitrées Lormont, vitrier Lormont');
    }

    // Open Graph tags
    let ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType) {
      ogType = document.createElement('meta');
      ogType.setAttribute('property', 'og:type');
      document.head.appendChild(ogType);
    }
    ogType.setAttribute('content', 'website');

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) {
      ogUrl = document.createElement('meta');
      ogUrl.setAttribute('property', 'og:url');
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute('content', 'https://reparation-fenetre-bordeaux.fr/lormont');

    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', 'Réparation Fenêtres Lormont | PVC Alu Bois | Baies Vitrées | FenetrePro');

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute('content', 'Expert en réparation de fenêtres à Lormont ✓ PVC, Aluminium, Bois ✓ Baies vitrées toutes marques ✓ Intervention rapide ✓ Devis gratuit ✓ Artisan local Lormont');

    let ogImage = document.querySelector('meta[property="og:image"]');
    if (!ogImage) {
      ogImage = document.createElement('meta');
      ogImage.setAttribute('property', 'og:image');
      document.head.appendChild(ogImage);
    }
    ogImage.setAttribute('content', 'https://public.readdy.ai/ai/img_res/1c6f6ba2961320365fe2b2b4dd6b178d.jpg');

    let ogImageWidth = document.querySelector('meta[property="og:image:width"]');
    if (!ogImageWidth) {
      ogImageWidth = document.createElement('meta');
      ogImageWidth.setAttribute('property', 'og:image:width');
      document.head.appendChild(ogImageWidth);
    }
    ogImageWidth.setAttribute('content', '1200');

    let ogImageHeight = document.querySelector('meta[property="og:image:height"]');
    if (!ogImageHeight) {
      ogImageHeight = document.createElement('meta');
      ogImageHeight.setAttribute('property', 'og:image:height');
      document.head.appendChild(ogImageHeight);
    }
    ogImageHeight.setAttribute('content', '630');

    const metaGeoPosition = document.querySelector('meta[name="geo.position"]');
    if (metaGeoPosition) {
      metaGeoPosition.setAttribute('content', '44.8778;-0.5222');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.position';
      meta.content = '44.8778;-0.5222';
      document.head.appendChild(meta);
    }

    const metaGeoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (metaGeoPlacename) {
      metaGeoPlacename.setAttribute('content', 'Lormont, Gironde, France');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.placename';
      meta.content = 'Lormont, Gironde, France';
      document.head.appendChild(meta);
    }

    const metaGeoRegion = document.querySelector('meta[name="geo.region"]');
    if (metaGeoRegion) {
      metaGeoRegion.setAttribute('content', 'FR-33');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.region';
      meta.content = 'FR-33';
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar city="Lormont" />
      <Hero city="Lormont" />
      <Services city="Lormont" />
      <BayWindows city="Lormont" />
      <WhatsAppDiagnostic city="Lormont" />
      <Contact city="Lormont" />
      <Footer city="Lormont" />
    </div>
  );
}